<template lang="">
    <form action="" class="" v-on:submit.prevent="createUser">
        <FormErrors :errors="vuelidate.$errors" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.user.name.$model" v-model="vuelidate.user.name.$model" />
        <InputComponent type="email" placeholder="Email" :value="vuelidate.user.email.$model" v-model="vuelidate.user.email.$model" />
        <InputComponent type="text" placeholder="Contraseña" :value="vuelidate.user.password.$model" v-model="vuelidate.user.password.$model" />
        <SelectInput placeholder="Rol" :items="[{id:'1',name:'user'},{id:'2',name:'admin'}]" :value="vuelidate.user.role_id.$model" v-model="vuelidate.user.role_id.$model" />
        <SubmitButtonComponent value="Guardar"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import FileInput from '../Forms/FileInput.vue'
import SelectInput from '../Forms/SelectInput.vue'
import useNotification from '../../Services/useNotification'

export default {
    components: {InputComponent,SubmitButtonComponent,FormErrors,FileInput,SelectInput,useNotification},
    props: ['user'],
    validations() {
        return {
            user: {
                name: {
                    required
                },
                email: {
                    required
                },
                password: {
                    required
                },
                role_id: {
                    required
                }
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const user= ref(props.user)
        const isEdit = user.value.name!=''
        const notificate = useNotification()

        const createUser = async()=>{
            let validation = await vuelidate.value.$validate();

            if(validation){
                let apiCall = null
                if(isEdit){
                    apiCall = api.updateUser(user.value)
                }else{
                    apiCall = api.addUser(user.value)
                }
                apiCall.then(response=>{
                    console.log(response)
                    notificate.success('Guardado con exito')
                    Inertia.reload()
                    emit('added')
                })
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        return{
            user,
            createUser,
            vuelidate,
            isEdit
        }
    }
}
</script>